// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".summary-container{background-color:#f5f5f6;color:rgba(0,0,0,.6);padding:0}.content-block{background-color:#fff;margin-bottom:8px;padding:0 8px 4px}.product-name-link,.product-pn-link{color:#0063a6;text-decoration:underline;cursor:pointer}.product-name-link{text-decoration:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
